<template>
	<div class="page landing">
		<div class="content" :class="isAnimationPlaying ? 'content-animate' : ''">
			<div class="link" @click="playAnimation()">
				<button to="Experience" class="white fs-2 coco p-0">
					{{ wording.landing.button }}
				</button>
			</div>
		</div>
		<div id="landing-canvas">
			<canvas touch-action="none" ref="canvas"></canvas>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.landing {
		box-sizing: border-box;
		position: relative;
		.content {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			background-color: rgba(255, 255, 255, 0.4);

			.link {
				box-sizing: border-box;
				padding: 1rem 2rem;
				display: flex;
				align-items: center;
				justify-content: center;

				background-color: var(--black-4);
				border: 1px solid var(--white);
				box-sizing: border-box;
				border-radius: 2.75rem;

				will-change: transform;
				transform: scale(1);
				transition: transform 0.3s ease-in;
				cursor: pointer;

				&:hover {
					transform: scale(1.03);
				}
			}

			&.content-animate {
				animation: 1s linear forwards ContentButton;
			}
		}
	}

	// button animation
	@keyframes ContentButton {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
			display: none;
		}
	}
</style>
<script>
	import * as Babylon from "babylonjs";
	import { GLTFFileLoader } from "babylonjs-loaders";
	import { mapState, mapMutations } from "vuex";
	import { options3D, wording } from "../js/constants.js";
	const W = {
		h: window.innerHeight,
		w: window.innerWidth,
	};
	window.addEventListener("resize", () => {
		W.w = window.innerWidth;
		W.h = window.innerHeight;
	});

	export default {
		data() {
			return {
				scene: null,
				engine: undefined,
				isAnimationPlaying: false,
				isEntityGood: false,
				deskCamera: null,
				wording,
			};
		},
		computed: {
			...mapState(["currentZoom", "content"]),
		},
		mounted() {
			this.$refs.canvas.width = W.w;
			this.$refs.canvas.height = W.h;
			this.engine = new Babylon.Engine(this.$refs.canvas, true);
			Babylon.SceneLoader.RegisterPlugin(new GLTFFileLoader());
			this.scene = this.createScene();

			this.loadDesk();

			this.engine.runRenderLoop(() => {
				this.scene.render();
			});
			window.addEventListener("resize", () => {
				this.engine.resize();
				if (typeof this.$refs.canvas !== "undefined") {
					this.$refs.canvas.width = W.w;
					this.$refs.canvas.height = W.h;
				}
			});
		},
		methods: {
			...mapMutations(["setIsEntityGood", "setSound"]),
			createScene() {
				let scene = new Babylon.Scene(this.engine);
				var camera = new Babylon.FreeCamera(
					"camera1",
					new Babylon.Vector3(options3D.x5.cameraPosition.x, options3D.x5.cameraPosition.y, options3D.x5.cameraPosition.z),
					scene
				);
				camera.setTarget(Babylon.Vector3.Zero());
				return scene;
			},
			loadDesk() {
				// loading the desk
				Babylon.SceneLoader.ShowLoadingScreen = false;
				Babylon.SceneLoader.Append("./assets/meshs/desk/", "desk.gltf", this.scene, (scene) => {
					this.deskCamera = scene.getCameraByName("Camera.001");
					scene.animationsEnabled = false;
					scene.activeCamera = this.deskCamera;
					scene.paused = true;
				});
			},
			// reste la
			playAnimation() {
				// play animation
				this.scene.animationsEnabled = true;
				this.scene.paused = false;
				this.isAnimationPlaying = true;
				this.scene.activeCamera = this.deskCamera;
				this.setSound(true);
				setTimeout(() => {
					this.scene.animationsEnabled = false;
					this.scene.paused = true;
					this.setIsEntityGood(true);

					// destroying the scene to prevent performace issues
					setTimeout(() => {
						this.scene.dispose();
					}, 3000);
				}, options3D.x5.cameraAnimationDuration);
			},
		},
	};
</script>
